<template>
	<div>
		<stepTitle :navItems="['LiveVR Classroom']" :index="1" :step="1"/>
	<div class="container my-4 px-0 py-5" style="background:#fff; min-height:80vh">
		<router-view></router-view>
	</div>
	</div>
</template>

<script>
import stepTitle from '../../Teacher/StepTitle'
export default {

  name: 'VRLayout',

  data () {
    return {
    }
  },

  methods: {
  },
  components: {
    stepTitle
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
	.menu-box {
		width: 60%;
		cursor: pointer;
		text-align: left;
		background-color: #fff;
		border-radius: 10px;
		border: 1.5px solid #6666;
		margin: 10px auto;
		padding: 10px 20px;
		p {
			margin: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// VRLayout.vue?2ad9ed04